import { render, staticRenderFns } from "./VentasXero.vue?vue&type=template&id=20edb89e&scoped=true&"
import script from "./VentasXero.vue?vue&type=script&scoped=true&lang=js&"
export * from "./VentasXero.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./VentasXero.vue?vue&type=style&index=0&id=20edb89e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20edb89e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VCardTitle,VCol,VDataTable,VIcon,VRow,VSnackbar,VTextField})
